import { Component } from "react";

import _ from "underscore";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

import ManualDepositItemForMatch from "./Accounting.Manual.Matching.Component";

import { numberWithSpaces } from "../../../utilities/formaters";
import PropTypes from "prop-types";

export default class AccountingDepositTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      latestValueForMatch: "",
    };
  }

  updateMachingValueDeposit = (latestValueForMatch) => {
    this.setState({ ...this.state, latestValueForMatch: latestValueForMatch });
  };

  manualMatch = (depositObject, machedData) => {
    this.props.manualMatchDeposit(depositObject.Id, machedData);
  };

  render() {
    let tabStle = { width: "50%", boxSizeing: "border-box", padding: "16px" };
    let leftTabStle = Object.assign({}, tabStle, { paddingRight: "8px" });
    let rightTabStle = Object.assign({}, tabStle, { paddingLeft: "8px" });
    let wrapperStyle = { display: "flex" };

    let providerIds = _.pluck(this.props.notMatchedDepositPayments, "Id");

    return (
      <div style={wrapperStyle}>
        <div style={leftTabStle}>
          <Card style={{ height: "100%" }}>
            <CardContent>
              <h3>Deposit payments</h3>
              <List>
                {this.props.notMatchedDepositPayments.map((item, index) => {
                  // add text underline if a part of id the same as the
                  // last put in match
                  let style = {};
                  style.textDecoration =
                    String(item.Id).indexOf(this.state.latestValueForMatch) >=
                      0 && this.state.latestValueForMatch
                      ? "underline"
                      : "none";

                  return [
                    <ListItem
                      key={index + "depositPayment"}
                      innerDivStyle={style}
                      disabled={true}
                    >
                      <ListItemText
                        primary={"Payment Id: " + item.Id}
                        secondary={
                          <span>
                            <span>
                              Amount:{" "}
                              <strong>
                                {numberWithSpaces(item.Amount.Amount)}
                              </strong>
                            </span>
                            <br />
                            <span>
                              Ref code: <strong>{item.RefCode}</strong>
                            </span>
                          </span>
                        }
                      />
                    </ListItem>,
                    <Divider key={index + "depositPayment-2"} />,
                  ];
                })}
              </List>
            </CardContent>
          </Card>
        </div>
        <div style={rightTabStle}>
          <Card style={{ height: "100%" }}>
            <CardContent>
              <h3>Deposits</h3>
              <List>
                {this.props.notMatchedDeposits.map((item, index) => {
                  return (
                    <ManualDepositItemForMatch
                      item={item}
                      key={index}
                      providerIds={providerIds}
                      manualMatch={this.manualMatch}
                      updateMachingValue={this.updateMachingValueDeposit}
                    />
                  );
                })}
              </List>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  static propTypes = {
    notMatchedDeposits: PropTypes.any,
    notMatchedDepositPayments: PropTypes.any,
    manualMatchDeposit: PropTypes.func.isRequired,
  };
}
